export default __webpack_public_path__ + "static/media/FPC_Notas_as_contas_2022.3f89aaa5.pdf";